// source: design/src/components/Header.tsx + design/src/components/Footer.tsx (export 2026-04-24)
export default {
  navList: [
    {
      id: 'products',
      title: '製品とサービス',
      link: '/products',
      subNav: [
        { title: 'IFS ソリューション', link: '/services_ifs-solution' },
        { title: 'SI システムインテグレーション', link: '/services_system-integration' },
        { title: 'ロボットソリューション', link: '/services_robot-solution' },
        { title: 'UI/UX デザイン＆開発', link: '/services_uiux-design' },
      ],
    },
    {
      id: 'work-cards',
      title: '実績',
      link: '/works',
      subNav: [],
    },
    { title: 'logo', link: '' },
    {
      id: 'home-about',
      title: '会社情報',
      link: '/home-about',
      subNav: [
        { title: '飛狼数碼（上海）有限公司', link: '/about_sh' },
        { title: '成都市飛狼科技有限公司', link: '/about_cd' },
        { title: '大連飛狼科技有限公司', link: '/about_dl' },
      ],
    },
    {
      id: 'recruit',
      title: '採用',
      link: '/recruit',
      subNav: [],
    },
    {
      id: 'news',
      title: 'ニュース',
      link: '/news',
      subNav: [],
    },
  ],
  productsMenu: {
    ifs: {
      title: 'IFS ソリューション',
      desc: 'エンドツーエンドのデジタルシステム統合サービス',
      link: '/ifs',
      children: [
        { title: 'ERP 企業資源計画', link: 'https://www.ifs.com/ja/products/erp' },
        { title: 'EAM 企業資産管理', link: 'https://www.ifs.com/ja/products/alm/eam' },
        { title: 'FSM 現場サービス管理', link: 'https://www.ifs.com/ja/products/fsm' },
        { title: '企業 AI ソリューション', link: 'https://www.ifs.com/ja/products/ai' },
      ],
    },
    si: {
      title: 'SI システムインテグレーション',
      desc: 'システムとデータを連携させ、効率的な協調体制を構築する',
      link: '/si',
      children: [
        { title: 'MES 製造実行システム', link: '/si/mes' },
        { title: 'WMS 倉庫管理システム', link: '/si/wms' },
        { title: 'AI', link: '/si/ai' },
      ],
    },
    rb: {
      title: 'ロボット',
      desc: 'IoT & ロボットを活用した企業向け検査ソリューション',
      link: '/robot',
    },
    uiux: {
      title: 'UI/UX デザイン＆開発',
      desc: 'ユーザーを中心としたデジタル体験の設計と開発',
      link: '/uiux',
    },
  },
  privacy_link: 'プライバシーポリシー',
  information_security_link: '情報セキュリティへの取り組み',
  beianIcp: '蜀 ICP 备 19005068 号',
  beian: '川公网安备 51019002002138 号',
  langList: [
    { title: '中文', code: 'zh' },
    { title: '日本語', code: 'ja' },
  ],
  contact: {
    title: '連絡方法',
    emailTitle: 'メール',
    url: 'info@fenrir-inc.com.cn',
    telTitle: '電話',
    tels: ['021-33639028（上海）', '028-85177409（成都)', '0411-83731889（大連)'],
    contactTitle: 'お問い合わせ',
  },
};
